import { BadgeProps } from '@silverfort/sf-components/dist/Badge/Badge';
import { MfaEnforcementStatus } from '../types/MfaEnforcementStatus';

export const MfaEnforcementStatusColors: Record<MfaEnforcementStatus, BadgeProps['color']> = {
    [MfaEnforcementStatus.ENFORCED]: 'positive',
    [MfaEnforcementStatus.UNENFORCED]: 'negative',
    [MfaEnforcementStatus.UNKNOWN]: 'secondary'
};
